const url = 'historicos';
class HistoricoService {
    async remover({ id }) {
        await window.$http.delete(`${url}/${id}`);
        return '';
    }
}

export default new HistoricoService();
